import Emails from './Subsheets/Emails.js'
import {Modal} from "bootstrap";
import ModalClass from "../html/modal.js";
import {closeSubsheet, loadSubsheet} from "../subsheets.js";


export default class SubsheetClass {



    _objList = {
        Emails: Emails,
        // AddBid: AddBid,
    }
    _handled = false
    _modal = false

    _obj
    _ctx
    info

    _body
    _title

    constructor(){
        // this._ctx = $('#CSSubsheetModal')
        this._body = $('<div>').html('Body...')
        this._title = $('<div>').html('Title...')
        // $('.modal-body', this._ctx).html(this._body).addClass('scrollable')

        this._modal = new ModalClass({
            id: 'CSSubsheetModal',
            title: this._title,
            body: this._body,
            modalClass: '',
            open: (e) => {},
            opened: (e) => {},
            close: (e) => { return this.close() },
            closed: (e) => { this.reset() },
            btn: [
                CS.Make.button({
                    content: 'Close',
                    type: 'warning',
                    obj: ModalClass.btn[0].removeClass('btn-close'),
                    // click: () => { this.close() }
                }),
                CS.Make.button({
                    content: 'Save',
                    type: 'success',
                    click: () => { this.save() }

                }),

            ]

        })
        // $('.btn-save', this._ctx).on('click',()=> {this.save(); return false; } )
        // $('#close', this._ctx).on('click',()=> {this.close(); return false; } )

    }

    addTopButton(obj){

        $('.modal-header #attach').html(obj)
    }

    get handled(){
        return this._handled
    }
    get body(){
        return this._body
    }

    set body(v){
        $(this._body).html(v)
    }

    set title(v){
        $(this._title).html(v)
    }

    open(){


        // if(!this._modal) {
        //     let modalObj = this._ctx;
        //     $(modalObj).on('show.bs.modal', function (e) {
        //
        //     });
        //
        //     $(modalObj).on('hidden.bs.modal', (e) => {
        //         this.close()
        //     })
        //     this._modal = new Modal(modalObj, {})
        // }
        this._modal.show()


        // $('.btn-save', modalObj).on('click',this.save);
        // $('#close', modalObj).on('click',this.close);

        return this
        // this._body = $('.modal-body', modalObj);
    }

    reset(){
        this._obj = {}
        this.body = CS.Make.spinner
        this.title = 'Loading...'
    }

    save(data){
        this._notif = CS.notif('warning', 'Saving...')
        if(!this._handled) data = CS.saveSubsheetData()
        else{
            if(this._obj.save) return

            if(this._obj.saveData)
                data = this._obj.saveData
            else
                data = CS.collectData(this._ctx)


            if(CS.getCurrentSubsheet().id) {
                data['subSheetID'] = CS.getCurrentSubsheet().id
            }else{
                data['colID'] = CS.getCurrentSubsheet().colID
            }
        }

        CS.makeCall({
            url: route('subsheet.save'),
            data: JSON.stringify(data),
            contentType: 'application/json'
        }, (r) => { this.handleResponse(r)})
    }

    load(data){
        this._handled = false
        // this.reset()
        CS.Subsheet.title = data.data.subsheetTitle
        // console.log('xxxx', data)
        if(data && (this._objList[data.subsheet.name]??false)){

            this.info = data.subsheet


            this._obj = new this._objList[data.subsheet.name](data)
            console.log("Creating subsheet", this)

            // $('.modal-body', this._ctx).html(this._obj.body)

            this._handled = true

            this.open()
            this._body = this._obj.body

            CS.setCurrentSubsheet(data.subsheet)

            // $('.subsheetTitle').html(data.data.subsheetTitle)

            // this._title = data.data.subsheetTitle


            //supportingData = r.data.supportingData ?? []

        }

        return this
    }

    handleResponse(r){
        if(r.newSubsheet){
            CS.loadSubsheet(r.newSubsheet)
        }

        if(r.reload)
            CS.reloadSubsheet()

        if(r.close)
            this._modal.hide()


        if(r.success && r.success[0] === 'Saved'){
            CS.resetFormInputs()
            CS.clearTrackedChanges()
            CS.showSuccess('Saved')
            this._notif.hide()
        }
    }

    close(){
        // CS.newSubsheet()
        console.log('close ss')

        if(CS.getUnsavedChanges() > 0){
            let common = () => {
                CS.clearTrackedChanges()
                this._modal.hide()
            }
            CS.confirm('Save before leaving?', () => {
                this.save()
                common()
            }, () => {
                common()

            })

            return false
        }
        return true

        // if(!CS.closeSubsheet()) return false
    }

    // collectData(){
    //     let out = $('input, textarea, select','.inputContainer').serializeArray()
    //
    //     let rowData = [];
    //     $('.dataRow', this._ctx).each((i,v) => {
    //         let d = $(v).find('input, select, textarea').serializeArray()
    //         rowData.push(cleanupSerial(d))
    //     })
    //
    //     let ret = {inputs: cleanupSerial(out), rowData: rowData}
    //     console.log('collectData', ret)
    //
    //     return ret
    // }

}
